export default __webpack_public_path__ + "static/media/red_notify.30aa3abd.svg";